import { Link } from "react-router-dom";

export default function ContactDetails() {
  return (
    <div className="min-h-screen flex flex-col items-center px-6 py-10 md:px-16 bg-gray-100 dark:bg-gray-900 text-gray-800 dark:text-white">
      <div className="max-w-4xl w-full bg-white dark:bg-gray-800 p-6 md:p-10 rounded-lg shadow-lg">
        <h1 className="text-3xl md:text-4xl font-bold mb-6 text-center">Contact Information</h1>

        <div className="space-y-6 text-center">
          <p className="text-lg">
            👤 <span className="font-semibold">Merchant Legal entity name:</span> SHIKHA JAIN
          </p>
          <p className="text-lg">
            📧 <span className="font-semibold">Email:</span> printkaro369@gmail.com
          </p>
          <p className="text-lg">
            📞 <span className="font-semibold">Phone:</span> +91 95606 34482
          </p>
          <p className="text-lg">
            📍 <span className="font-semibold">Address:</span> House No-B-71,Ground Floor Right
            Side,, Nhpc Colony Faridabad, Haryana, PIN: 121010
          </p>
        </div>

        <div className="mt-6 text-center">
          <Link to="/" className="text-indigo-600 dark:text-indigo-400 hover:underline">
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}
